import Vue from "vue";

export const JobEventBus = new Vue();
